import {API} from "@/app/_api/types/auth";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {comRequest} from "@/Fwk/Http/comRequest";
import {NetType} from "@/Fwk/Http/NetType";

export async function userLogin(params: object): Promise<API.UserLoginResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.Login),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API.UserLoginResponse>(config);
    return response.data;
}

export async function userSignUp(params: object): Promise<API.UserSignUpResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.Register),
        method: 'POST',
        body: params,
    }
    const response = await DoSendRequest<API.UserSignUpResponse>(config);
    return response.data;
}

export async function visitorLogin(params: object = {}): Promise<API.VisitorLoginResponse> {
    const config:HttpConfig = {
        url: RequestMgr.getUrl(NetType.visitorLogin),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API.VisitorLoginResponse>(config);
    return response.data;
}

export async function checkPhoneRegister(params: object = {}): Promise<API.CheckPhoneRegisterResponse> {
    const response = await checkPhoneRegisterCom(params);
    return response.data;
}

export async function checkPhoneRegisterCom(params: object = {}): Promise<HttpResponse<API.CheckPhoneRegisterResponse>> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.CheckRegister),
        method: 'POST',
        body: params,
    };
    return await DoSendRequest<API.CheckPhoneRegisterResponse>(config);
}


export async function checkSmsCode(params: object = {}) {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.CheckCode),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API.CheckSmsCodeResponse>(config);
    return response.data;
}

export async function userResetPassword(params: object = {}) {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.ResetPwd),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API.CheckSmsCodeResponse>(config);
    return response.data;
}

export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}